import React, {useEffect, useState} from "react";
import {LookDataType} from "./LookTypes";
import SwiperBuilder, {defaultBreakpoints} from "../crossSelling/SwiperBuilder";
import {useTranslation} from "react-i18next";
import LookItem from "./LookItem";
import {BreakpointType} from "../../molecules/SwiperTypes";
import {fetchTagRelatedLooks, ResponseError} from "./stlHelper";

/* eslint-disable no-underscore-dangle */

type TagsPropsType = {currentLook: LookDataType; setLook: React.Dispatch<React.SetStateAction<LookDataType | null>>};

// _Outdoor_ wird schon durch genug andere "Räume" wie "Garten" oder "Terrasse" abgedeckt
// _Minimalistisch_ ist zu minimalistisch
const tagsToFilterOut = ["room:Outdoor", "designStyle:Minimalistisch"];

const lookSliderBreakpoints: BreakpointType = {...defaultBreakpoints};
if (lookSliderBreakpoints["0"]) {
  lookSliderBreakpoints["0"] = {...lookSliderBreakpoints["0"], slidesPerView: 1.5};
}

const TagRelatedLooksSliders: React.FC<TagsPropsType> = ({currentLook, setLook}) => {
  const [allFirstTags, setAllFirstTags] = useState<string[]>([]);

  useEffect(() => {
    const tagsObj: {[key: string]: string[]} = {};
    const filteredTags = currentLook.tags.filter((tg) => !tagsToFilterOut.includes(tg));

    for (const filteredTag of filteredTags) {
      const tagKey = filteredTag.split(":")[0];

      // Namespace (der Teil vor dem Doppelpunkt) als key, und unter diesem die tags als string array speichern
      tagsObj[tagKey] = [...(tagsObj[tagKey] || []), filteredTag];

      const objValues = Object.values(tagsObj);
      if (objValues.length === 2 && objValues[1].length === 2) break;
    }

    // Nur die beiden ersten namespace keys nehmen
    const [first, second] = Object.keys(tagsObj).slice(0, 2);

    // Von denen jeweils nur die ersten beiden tags nehmen (maximal 4)
    setAllFirstTags([...tagsObj[first].slice(0, 2), ...tagsObj[second].slice(0, 2)]);
  }, [currentLook]);

  if (!allFirstTags.length) {
    return null;
  }

  return (
    <React.Fragment>
      {allFirstTags.map((tagString, index) => (
        <TagRelatedLooks key={index} setLook={setLook} tagString={tagString} currentLookId={currentLook._id} />
      ))}
    </React.Fragment>
  );
};

const TagRelatedLooks: React.FC<{
  tagString: string;
  currentLookId: string;
  setLook: React.Dispatch<React.SetStateAction<LookDataType | null>>;
}> = ({currentLookId, setLook, tagString}) => {
  const [looks, setLooks] = useState<LookDataType[] | null>(null);
  const {t} = useTranslation();

  useEffect(() => {
    const usp = new URLSearchParams();
    usp.set("taglist", tagString);

    void fetchTagRelatedLooks(tagString)
      .then((result) => {
        const looksWithoutCurrent = result.filter((look) => look._id !== currentLookId);
        if (looksWithoutCurrent.length >= 4) {
          setLooks(looksWithoutCurrent);
        }
      })
      .catch((error: ResponseError) => {
        // eslint-disable-next-line no-console
        if (__DEVELOPMENT__) console.error("DEVELOP:", JSON.stringify(error.data));
      });
  }, [currentLookId]);

  if (!looks) {
    return null;
  }

  return (
    <div className="pos-rel">
      <SwiperBuilder
        title={t("shopthelook.furtherLooksTo--tag", {tag: tagString.split(":")[1]}).toUpperCase()}
        breakpoints={lookSliderBreakpoints}
      >
        {looks.map((look, key) => {
          const {origin, pathname, search} = window.location;

          const usp = new URLSearchParams(search);
          usp.set("look-id", look._id);
          const href = origin + pathname + "?" + usp.toString();

          const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
            event.preventDefault();
            window.scrollTo({top: 0, behavior: "instant"});
            window.history.pushState(window.history.state, "clicked related look", href);
            setLook(look);
          };

          return <LookItem key={key} look={look} href={href} onClick={onClick} />;
        })}
      </SwiperBuilder>
    </div>
  );
};

export default TagRelatedLooksSliders;
